import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore';
import type { ZrmLeaseInfo, ZrmListingInfo, ZrmUserInfo } from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackEvent = analytics.createTrackEvent('CLICKSTREAM');

export const trackUserListingEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmListingInfo & ZrmUserInfo>(
  'CLICKSTREAM',
);

export const trackLeaseListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ZrmLeaseInfo & ZrmListingInfo & ZrmUserInfo
>('CLICKSTREAM');
